const ChatAttachmentMetadataRules = [
    {
        itemprop: 'name',
        itemtype: { type: 'string' },
        optional: true
    },
    {
        itemprop: 'mimeType',
        itemtype: { type: 'string' },
        optional: true
    },
    {
        itemprop: 'size',
        itemtype: { type: 'number' },
        optional: true
    },
    {
        itemprop: 'preview',
        itemtype: { type: 'string' },
        optional: true
    },
    {
        itemprop: 'thumbnailHash',
        itemtype: {
            type: 'referenceToObj',
            allowedTypes: new Set(['BlobDescriptor'])
        },
        optional: true
    }
];
export const ChatAttachmentRecipe = {
    $type$: 'Recipe',
    name: 'ChatAttachment',
    rule: [
        {
            itemprop: 'hash',
            itemtype: { type: 'referenceToClob' }
        },
        {
            itemprop: 'type',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'metadata',
            itemtype: {
                type: 'object',
                rules: ChatAttachmentMetadataRules
            },
            optional: true
        }
    ]
};
export const ChatRequestRecipe = {
    $type$: 'Recipe',
    name: 'ChatRequest',
    rule: [
        {
            itemprop: 'for',
            itemtype: { type: 'string' }
        }
    ]
};
export const ChannelInitRecipe = {
    $type$: 'Recipe',
    name: 'ChannelInit',
    rule: [
        {
            itemprop: 'sender',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        }
    ]
};
export const ChatMessageRecipe = {
    $type$: 'Recipe',
    name: 'ChatMessage',
    rule: [
        {
            itemprop: 'text',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'attachments',
            itemtype: {
                type: 'array',
                item: {
                    type: 'referenceToObj',
                    allowedTypes: new Set(['ChatAttachment']) // References to ChatAttachment index objects
                }
            },
            optional: true
        },
        {
            itemprop: 'sender',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'thumbnails',
            itemtype: {
                type: 'array',
                item: {
                    type: 'referenceToObj',
                    allowedTypes: new Set(['*'])
                }
            },
            optional: true
        }
    ]
};
const TopicAISettingsRules = [
    {
        itemprop: 'analyse',
        itemtype: { type: 'boolean' }
    },
    {
        itemprop: 'respond',
        itemtype: { type: 'boolean' }
    },
    {
        itemprop: 'ignore',
        itemtype: { type: 'boolean' }
    },
    {
        itemprop: 'joinedAt',
        itemtype: { type: 'number' }
    }
];
export const TopicRecipe = {
    $type$: 'Recipe',
    name: 'Topic',
    rule: [
        {
            // Participants hash - identity field
            itemprop: 'participants',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['HashGroup']) },
            isId: true
        },
        {
            // Original name for identity (undefined for P2P topics)
            itemprop: 'originalName',
            itemtype: { type: 'string' },
            isId: true,
            optional: true
        },
        {
            itemprop: 'channel',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['ChannelInfo']) }
        },
        {
            // Mutable display name (not part of identity)
            itemprop: 'displayName',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'aiParticipants',
            itemtype: {
                type: 'map',
                key: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
                value: { type: 'object', rules: TopicAISettingsRules }
            },
            optional: true
        },
        {
            // Certificate affirming the ChannelInfo - ensures CHUM delivers cert with Topic
            itemprop: 'channelCertificate',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['AffirmationCertificate']) },
            optional: true
        },
        {
            // Reference to Group for group conversations (undefined for P2P)
            itemprop: 'group',
            optional: true,
            itemtype: {
                type: 'referenceToId',
                allowedTypes: new Set(['Group'])
            }
        },
        {
            // AI Persons currently responding (each instance adds/removes its AI)
            itemprop: 'aiResponding',
            optional: true,
            itemtype: {
                type: 'set',
                item: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
            }
        },
        {
            // Persons currently composing a message - personId -> timestamp when started
            itemprop: 'composing',
            optional: true,
            itemtype: {
                type: 'map',
                key: { type: 'referenceToId', allowedTypes: new Set(['Person']) },
                value: { type: 'number' }
            }
        }
    ]
};
export const TopicAppRegistryRecipe = {
    $type$: 'Recipe',
    name: 'TopicAppRegistry',
    rule: [
        {
            itemprop: 'id',
            isId: true,
            itemtype: { type: 'string', regexp: /^TopicAppRegistry$/ }
        },
        {
            itemprop: 'topics',
            itemtype: {
                type: 'map',
                key: { type: 'string' },
                value: { type: 'referenceToId', allowedTypes: new Set(['Topic']) }
            }
        }
    ]
};
const ChatRecipes = [
    ChatAttachmentRecipe,
    ChatMessageRecipe,
    ChatRequestRecipe,
    ChannelInitRecipe,
    TopicRecipe,
    TopicAppRegistryRecipe
];
export default ChatRecipes;
//# sourceMappingURL=ChatRecipes.js.map